import { render } from "./PaintingProduceAchievement.vue?vue&type=template&id=6638b9e1&scoped=true"
import script from "./PaintingProduceAchievement.vue?vue&type=script&lang=js"
export * from "./PaintingProduceAchievement.vue?vue&type=script&lang=js"

import "./PaintingProduceAchievement.vue?vue&type=style&index=0&id=6638b9e1&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6638b9e1"]])

export default __exports__